import { EditLeaveApplicationForm } from "./_components/edit-leave-application-form";

const EditLeaveApplicationAsEmployee = () => {
  return (
    <div className="p-2 md:h-[calc(100%-56px)] h-[calc(100vh-56px)]">
      <div className="h-full rounded-md">
        <EditLeaveApplicationForm />
      </div>
    </div>
  );
};

export default EditLeaveApplicationAsEmployee;
